// 每日签收派单「手动比例」的纯计算：以 0.01% 为单位做最大余数分配，合计严格等于 target。

const numberWeight = value => {
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}

export function evenWeights(scope, target = 100) {
  if (!scope.length) return {}
  const want = Math.round(target * 100)
  const base = Math.floor(want / scope.length)
  return Object.fromEntries(scope.map((p, index) => [p.id, (index === scope.length - 1 ? want - base * (scope.length - 1) : base) / 100]))
}

export function rebaseWeights(source, scope, target = 100) {
  if (!scope.length) return {}
  const want = Math.round(target * 100)
  const entries = scope.map(p => ({ id: p.id, raw: Math.max(0, numberWeight(source[p.id])) }))
  const total = entries.reduce((sum, item) => sum + item.raw, 0)
  // Newly resumed people are absent from source and intentionally enter at 0%; the previous pool keeps the full target.
  if (!total) return evenWeights(scope, target)
  // 以整数百分位做最大余数分配：精确凑满 target，也绝不把舍入尾差塞给原本 0% 的人。
  const portions = entries.map(item => {
    const exact = item.raw / total * want
    const cents = Math.floor(exact)
    return { ...item, cents, fraction: exact - cents }
  })
  let remaining = want - portions.reduce((sum, item) => sum + item.cents, 0)
  portions.filter(item => item.raw > 0).sort((a, b) => b.fraction - a.fraction || String(a.id).localeCompare(String(b.id))).forEach(item => {
    if (remaining > 0) { item.cents += 1; remaining -= 1 }
  })
  return Object.fromEntries(portions.map(item => [item.id, item.cents / 100]))
}

// 只改一个人：他取 value（限制在 0–100、保留两位），其余人按 base 里原来的比例分剩下的；只有他一个人时固定 100。
// locked：被锁定的人保持 base 里的比例不动，只在没锁的人之间分配；他的上限是 100 减去锁定合计，没人可分时直接取这个余量。
export function balanceWeight(base, scope, id, value, locked = []) {
  const lockedIds = new Set(locked.map(String))
  const rest = scope.filter(p => p.id !== id)
  const fixed = rest.filter(p => lockedIds.has(String(p.id)))
  const free = rest.filter(p => !lockedIds.has(String(p.id)))
  const fixedCents = Math.min(10000, fixed.reduce((sum, p) => sum + Math.round(Math.max(0, numberWeight(base[p.id])) * 100), 0))
  const room = 10000 - fixedCents
  const own = (!rest.length ? 10000 : free.length ? Math.min(room, Math.max(0, Math.round(numberWeight(value) * 100))) : room) / 100
  return {
    ...rebaseWeights(base, free, (room - Math.round(own * 100)) / 100),
    ...Object.fromEntries(fixed.map(p => [p.id, Math.round(Math.max(0, numberWeight(base[p.id])) * 100) / 100])),
    [id]: own,
  }
}
